import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{textAlign:"center"}}>
    <h1>Something went wrong!</h1>
    <Link to="/">
      Go Home
    </Link>
  </div>
);

export default NotFound;